<template>
  <v-app>
    <Header ref="header"/>
    <Sidebar/>
    <v-content>
      <v-tabs v-model="active" slider-color="#004d40" class="tabs">
        <v-tab v-on:click="loadCategoryColors" style="width: 180px !important;">Category colors</v-tab>
        <v-tab-item>
          <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
            <v-layout>
              <v-flex text-xs-right>
                <v-btn flat v-if="!currentCategoryColor" @click="addCategoryColor" class="bw-8">Create new category color</v-btn>
                <v-btn flat v-if="currentCategoryColor" @click="saveCategoryColor" class="bw-3">Save</v-btn>
                <v-btn flat v-if="currentCategoryColor && currentCategoryColor.id > 0" @click="confirmDeleteCategoryColorDialog = true" class="bw-3">Delete</v-btn>
                <v-btn flat v-if="currentCategoryColor" @click="cancelCategoryColor" class="bw-3">Cancel</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
            <v-layout style="max-height: calc(100vh - 210px);">
              <v-flex v-if="categoryColors.length > 0 && !currentCategoryColor" text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
                <v-data-table :headers="categoryColorHeaders" :items="categoryColors" hide-actions>
                  <template v-slot:items="props">
                    <tr @click="selectCategoryColor(props.item)" class="selectable">
                      <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.name }}</td>
                      <td class="text-xs-left" style="width: 100%;" v-if="!(props.item.secondColor && props.item.secondColor !== '')">
                        <div :style="'margin: 2px; border-radius: 3px; border: 1px solid #BBBBBB; padding: 4px 5px; text-align: center; width: 100% !important; background-color: #' + props.item.color + ';'">&nbsp;</div>
                      </td>
                      <td class="text-xs-left" style="width: 100%;" v-if="props.item.secondColor && props.item.secondColor !== ''">
                        <div :style="'margin: 2px; border-radius: 3px; border: 1px solid #BBBBBB; padding: 4px 5px; text-align: center; width: 100% !important; background: repeating-linear-gradient(-45deg, #' + props.item.color + ', #' + props.item.color + ' 3px, #' + props.item.secondColor + ' 3px, #' + props.item.secondColor + ' 6px);'">&nbsp;</div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
          <Panel v-if="currentCategoryColor">
            <PanelColumn title="Category color">
              <v-flex xs4 sm3 md2>
                <v-label>Name</v-label>
              </v-flex>
              <v-flex xs8 sm9 md10>
                <v-text-field color="teal" v-model="currentCategoryColor.name" ref="categoryColorName" autocomplete="offit"></v-text-field>
              </v-flex>

              <v-flex xs4 sm3 md2>
                <v-label>Two colors</v-label>
              </v-flex>
              <v-flex xs8 sm9 md10>
                <v-checkbox color="teal" v-model="hasSecondColor" style="margin-left: -2px; padding-top: 0 !important;"></v-checkbox>
              </v-flex>

              <v-flex xs4 sm3 md2>
                <v-label>Color</v-label>
              </v-flex>
              <v-flex xs8 sm9 md10>
                <div :style="'height: 25px; margin: 2px; margin-left: 0; border-radius: 3px; border: 1px solid #BBBBBB; padding: 4px 5px; text-align: center; width: 100% !important; ' + colorCss + ' color: ' + colorText + ';'"></div>
              </v-flex>

              <v-flex xs12 py-4>
                <v-divider/>
              </v-flex>

              <v-flex xs1 style="padding: 0 20px;">
                <div style="width: 20px; height: 20px; background-color: red; border-radius: 3px;"></div>
              </v-flex>
              <v-flex xs10 px-3>
                <v-slider v-model="colorRed" :min="0" :max="255" step="12.75"></v-slider>
              </v-flex>
              <v-flex xs1 text-xs-right px-2>
                {{ Math.round(this.colorRed * 100 / 255) + ' %' }}
              </v-flex>

              <v-flex xs1 style="padding: 0 20px;">
                <div style="width: 20px; height: 20px; background-color: green; border-radius: 3px;"></div>
              </v-flex>
              <v-flex xs10 px-3>
                <v-slider v-model="colorGreen" :min="0" :max="255" step="12.75"></v-slider>
              </v-flex>
              <v-flex xs1 text-xs-right px-2>
                {{ Math.round(this.colorGreen * 100 / 255) + ' %' }}
              </v-flex>

              <v-flex xs1 style="padding: 0 20px;">
                <div style="width: 20px; height: 20px; background-color: blue; border-radius: 3px;"></div>
              </v-flex>
              <v-flex xs10 px-3>
                <v-slider v-model="colorBlue" :min="0" :max="255" step="12.75"></v-slider>
              </v-flex>
              <v-flex xs1 text-xs-right px-2>
                {{ Math.round(this.colorBlue * 100 / 255) + ' %' }}
              </v-flex>

              <v-flex xs12 py-3 v-if="hasSecondColor">
              </v-flex>

              <v-flex xs1 style="padding: 0 20px;" v-if="hasSecondColor">
                <div style="width: 20px; height: 20px; background-color: red; border-radius: 3px;"></div>
              </v-flex>
              <v-flex xs10 px-3 v-if="hasSecondColor">
                <v-slider v-model="secondColorRed" :min="0" :max="255" step="12.75"></v-slider>
              </v-flex>
              <v-flex xs1 text-xs-right px-2 v-if="hasSecondColor">
                {{ Math.round(this.secondColorRed * 100 / 255) + ' %' }}
              </v-flex>

              <v-flex xs1 style="padding: 0 20px;" v-if="hasSecondColor">
                <div style="width: 20px; height: 20px; background-color: green; border-radius: 3px;"></div>
              </v-flex>
              <v-flex xs10 px-3 v-if="hasSecondColor">
                <v-slider v-model="secondColorGreen" :min="0" :max="255" step="12.75"></v-slider>
              </v-flex>
              <v-flex xs1 text-xs-right px-2 v-if="hasSecondColor">
                {{ Math.round(this.secondColorGreen * 100 / 255) + ' %' }}
              </v-flex>

              <v-flex xs1 style="padding: 0 20px;" v-if="hasSecondColor">
                <div style="width: 20px; height: 20px; background-color: blue; border-radius: 3px;"></div>
              </v-flex>
              <v-flex xs10 px-3 v-if="hasSecondColor">
                <v-slider v-model="secondColorBlue" :min="0" :max="255" step="12.75"></v-slider>
              </v-flex>
              <v-flex xs1 text-xs-right px-2 v-if="hasSecondColor">
                {{ Math.round(this.secondColorBlue * 100 / 255) + ' %' }}
              </v-flex>

            </PanelColumn>
          </Panel>
        </v-tab-item>

        <v-tab v-on:click="loadFamilies" style="width: 170px !important;">Category families</v-tab>
        <v-tab-item>
          <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
            <v-layout>
              <v-flex text-xs-right>
                <v-btn flat v-if="!currentFamily" @click="addFamily" class="bw-8">Create new category family</v-btn>
                <v-btn flat v-if="currentFamily" @click="saveFamily" class="bw-3">Save</v-btn>
                <v-btn flat v-if="currentFamily && currentFamily.id > 0" @click="confirmDeleteFamilyDialog = true" class="bw-3">Delete</v-btn>
                <v-btn flat v-if="currentFamily" @click="cancelFamily" class="bw-3">Cancel</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
            <v-layout style="max-height: calc(100vh - 210px);">
              <v-flex v-if="!currentFamily" text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
                <v-data-table :headers="familyHeaders" :items="families" hide-actions>
                  <template v-slot:items="props">
                    <tr @click="selectFamily(props.item)" class="selectable">
                      <td class="text-xs-left" style="white-space: nowrap; width: 100px;">{{ props.item.quality }}</td>
                      <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.label }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
          <Panel v-if="currentFamily">
            <PanelColumn title="Category family">
              <v-flex xs12 sm3 md2>
                <v-label>Quality</v-label>
              </v-flex>
              <v-flex xs12 sm4 md2>
                <v-text-field color="teal" v-model="currentFamily.quality" ref="familyQuality" autocomplete="offit"></v-text-field>
              </v-flex>
              <v-flex xs0 sm5 md8 style="height: 10px;">&nbsp;</v-flex>

              <v-flex xs12 sm3 md2>
                <v-label>Label</v-label>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field color="teal" v-model="currentFamily.label" ref="familyLabel" autocomplete="offit"></v-text-field>
              </v-flex>
              <v-flex xs0 sm3 md6 style="height: 10px;">&nbsp;</v-flex>
            </PanelColumn>
          </Panel>
        </v-tab-item>

        <v-tab v-on:click="loadOptions" style="width: 120px !important;">Options</v-tab>
        <v-tab-item>
          <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
            <v-layout>
              <v-flex text-xs-right>
                <v-btn flat v-if="!currentOption" @click="addOption" class="bw-6">Create new option</v-btn>
                <v-btn flat v-if="currentOption" @click="saveOption" class="bw-3">Save</v-btn>
                <v-btn flat v-if="currentOption" @click="cancelOption" class="bw-3">Cancel</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
            <v-layout style="max-height: calc(100vh - 210px);">
              <v-flex v-if="!currentOption" text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
                <v-data-table :headers="optionHeaders" :items="options" hide-actions>
                  <template v-slot:items="props">
                    <tr @click="selectOption(props.item)" class="selectable">
                      <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.name }}</td>
                      <td class="text-xs-left" style="width: 50px !important;">{{ props.item.inactive ? 'Yes' : 'No' }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
          <Panel v-if="currentOption">
            <PanelColumn title="Option">
              <v-flex xs4 sm3 md2>
                <v-label>Name</v-label>
              </v-flex>
              <v-flex xs8 sm9 md10>
                <v-text-field color="teal" v-model="currentOption.name" ref="optionName" autocomplete="offit"></v-text-field>
              </v-flex>

              <v-flex xs4 sm3 md2>
                <v-label>Inactive</v-label>
              </v-flex>
              <v-flex xs8 sm9 md10>
                <v-checkbox color="teal" v-model="currentOption.inactive"/>
              </v-flex>
            </PanelColumn>
          </Panel>
        </v-tab-item>

        <v-tab v-on:click="loadPickupAddresses" style="width: 180px !important;">Loading addresses</v-tab>
        <v-tab-item>
          <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
            <v-layout>
              <v-flex text-xs-right>
                <v-btn flat v-if="!currentPickupAddress" @click="addPickupAddress" class="bw-8">Create new loading address</v-btn>
                <v-btn flat v-if="currentPickupAddress" @click="savePickupAddress" class="bw-3">Save</v-btn>
                <v-btn flat v-if="currentPickupAddress && currentPickupAddress.id > 0" @click="confirmDeletePickupAddressDialog = true" class="bw-3">Delete</v-btn>
                <v-btn flat v-if="currentPickupAddress" @click="cancelPickupAddress" class="bw-3">Cancel</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
            <v-flex v-if="pickupAddresses.length > 0 && !currentPickupAddress" text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
              <v-data-table :headers="pickupAddressHeaders" :items="pickupAddresses" hide-actions>
                <template v-slot:items="props">
                  <tr @click="selectPickupAddress(props.item)" class="selectable">
                    <td class="text-xs-left">{{ props.item.street }}</td>
                    <td class="text-xs-left" style="width: 60px !important;">{{ props.item.houseNo }}</td>
                    <td class="text-xs-left" style="width: 200px !important;">{{ props.item.location }}</td>
                    <td class="text-xs-left" style="width: 100px !important;">{{ props.item.zipCode }}</td>
                    <td class="text-xs-left" style="width: 200px !important;">{{ props.item.city }}</td>
                    <td class="text-xs-left" style="width: 150px !important;">{{ props.item.country }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-container>
          <Panel v-if="currentPickupAddress">
            <PanelColumn2 title="Loading address">
              <v-flex xs4 sm3>
                <v-label>Street</v-label>
              </v-flex>
              <v-flex xs8 sm9>
                <v-text-field color="teal" v-model="currentPickupAddress.street" ref="deliveryAddressStreet" autocomplete="offit"></v-text-field>
              </v-flex>

              <v-flex xs4 sm3>
                <v-label>House no.</v-label>
              </v-flex>
              <v-flex xs8 sm9>
                <v-text-field color="teal" v-model="currentPickupAddress.houseNo" style="width: 75px;" autocomplete="offit"></v-text-field>
              </v-flex>

              <v-flex xs4 sm3>
                <v-label>Location</v-label>
              </v-flex>
              <v-flex xs8 sm9>
                <v-text-field color="teal" v-model="currentPickupAddress.location" autocomplete="offit"></v-text-field>
              </v-flex>

              <v-flex xs4 sm3>
                <v-label>Postal code</v-label>
              </v-flex>
              <v-flex xs8 sm9>
                <v-text-field color="teal" v-model="currentPickupAddress.zipCode" style="width: 100px" autocomplete="offit"></v-text-field>
              </v-flex>

              <v-flex xs4 sm3>
                <v-label>City</v-label>
              </v-flex>
              <v-flex xs8 sm9>
                <v-text-field color="teal" v-model="currentPickupAddress.city" autocomplete="offit"></v-text-field>
              </v-flex>

              <v-flex xs4 sm3>
                <v-label>Country</v-label>
              </v-flex>
              <v-flex xs8 sm9>
                <v-text-field color="teal" v-model="currentPickupAddress.country" autocomplete="offit"></v-text-field>
              </v-flex>

              <v-flex xs4 sm3>
                <v-label>Geo code</v-label>
              </v-flex>
              <v-flex xs4 sm4>
                <v-text-field color="teal" v-model="currentPickupAddress.latitude" autocomplete="offit"></v-text-field>
              </v-flex>
              <v-flex xs4 sm4 style="padding-left: 10px;">
                <v-text-field color="teal" v-model="currentPickupAddress.longitude" autocomplete="offit"></v-text-field>
              </v-flex>
              <v-flex xs12 text-xs-right>
                <v-btn @click="$refs.pamaps.addressToGeo(currentPickupAddress)" flat>Lookup geo code</v-btn>
              </v-flex>
            </PanelColumn2>
            <v-flex xs12 class="hidden-md-and-up" style="height: 25px;"></v-flex>
            <PanelColumn2 style="padding-top: 25px;">
              <Maps v-model="currentPickupAddress" ref="pamaps" height="285px"/>
            </PanelColumn2>
          </Panel>
        </v-tab-item>

        <v-tab v-on:click="loadEmployeeTasks" style="width: 180px !important;">Employee tasks</v-tab>
        <v-tab-item>
          <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
            <v-layout>
              <v-flex text-xs-right>
                <v-btn flat v-if="!currentEmployeeTask" @click="addEmployeeTask" class="bw-8">Create new employee task</v-btn>
                <v-btn flat v-if="currentEmployeeTask" @click="saveEmployeeTask" class="bw-3">Save</v-btn>
                <v-btn flat v-if="currentEmployeeTask && currentEmployeeTask.id > 0" @click="confirmDeleteEmployeeTaskDialog = true" class="bw-3">Delete</v-btn>
                <v-btn flat v-if="currentEmployeeTask" @click="cancelEmployeeTask" class="bw-3">Cancel</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
            <v-layout style="max-height: calc(100vh - 210px);">
              <v-flex v-if="!currentEmployeeTask" text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
                <v-data-table :headers="employeeTaskHeaders" :items="employeeTasks" hide-actions>
                  <template v-slot:items="props">
                    <tr @click="selectEmployeeTask(props.item)" class="selectable">
                      <td class="text-xs-left" style="vertical-align: top;">
                        <div style="padding-top: 5px;">{{ props.item.title }}</div>
                      </td>
                      <td class="text-xs-left">
                        <div v-html="props.item.description" style="white-space: pre-wrap; padding: 5px 0;"/>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
          <Panel v-if="currentEmployeeTask">
            <PanelColumn title="Employee task">
              <v-flex xs4 sm3>
                <v-label>Title</v-label>
              </v-flex>
              <v-flex xs8 sm9>
                <v-text-field color="teal" v-model="currentEmployeeTask.title" ref="employeeTaskTitle" autocomplete="offit"></v-text-field>
              </v-flex>

              <v-flex xs4 sm3>
                <v-label>Description</v-label>
              </v-flex>
              <v-flex xs8 sm9>
                <v-textarea solo auto-grow flat rows="3" v-model="currentEmployeeTask.description" maxlength="1000"/>
              </v-flex>
            </PanelColumn>
          </Panel>
        </v-tab-item>

        <v-tab v-on:click="loadTimeRegistration" style="width: 180px !important;">Time registration</v-tab>
        <v-tab-item>
          <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
            <v-layout>
              <v-flex text-xs-right>
                <v-btn flat v-if="currentTimeRegistration" @click="saveTimeRegistration" class="bw-3">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <Panel v-if="currentTimeRegistration">
            <v-container fluid pa-1>
              <v-layout wrap>
                <v-flex xs12 md3 lg2>
                  <div style="padding-top: 35px;">
                    <v-label>Start day of month</v-label>
                  </div>
                </v-flex>
                <v-flex xs12 md9 lg10>
                  <div style="width: 50%; height: 200px; padding-top: 35px;">
                    <v-slider v-model="currentTimeRegistration.startDay" step="1" min="1" max="31" hide-details thumb-label="always" style="margin-top: 25px;"/>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </Panel>
        </v-tab-item>

        <v-tab v-on:click="loadForecast" style="width: 120px !important;">Forecast</v-tab>
        <v-tab-item>
          <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
            <v-layout>
              <v-flex text-xs-right>
                <v-btn flat :disabled="saveForecastDisabled" @click="saveForecast" class="bw-3">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <Panel title="Forecast">
            <v-flex xs4 sm3 md2>
              <v-label>Historic seasons</v-label>
            </v-flex>
            <v-flex xs6 sm6 md4>
              <v-text-field color="teal" v-model="forecastFoundationSeasonCount" autocomplete="offit" @change="dirty = true" @keyup="dirty = true" style="width: 30px;"></v-text-field>
            </v-flex>
            <v-flex xs2 sm3 md6/>

            <v-flex xs4 sm3 md2>
              <v-label>Number of years</v-label>
            </v-flex>
            <v-flex xs6 sm6 md4>
              <v-text-field color="teal" v-model="forecastYears" autocomplete="offit" @change="dirty = true" @keyup="dirty = true" style="width: 30px;"></v-text-field>
            </v-flex>
            <v-flex xs2 sm3 md6/>
          </Panel>
        </v-tab-item>

        <v-tab v-on:click="loadMailServer">Mail</v-tab>
        <v-tab-item>
          <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
            <v-layout>
              <v-flex text-xs-right>
                <v-btn flat v-on:click="saveMailServer">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <Panel title="Mail server">
            <v-flex xs4 sm3 md2>
              <v-label>Host name</v-label>
            </v-flex>
            <v-flex xs6 sm6 md4>
              <v-text-field color="teal" v-model="mailServerHost" autocomplete="offit"></v-text-field>
            </v-flex>
            <v-flex xs2 sm3 md6/>

            <v-flex xs4 sm3 md2>
              <v-label>Host port</v-label>
            </v-flex>
            <v-flex xs6 sm6 md4>
              <v-text-field color="teal" v-model="mailServerPort" style="width: 80px;" autocomplete="offit"></v-text-field>
            </v-flex>
            <v-flex xs2 sm3 md6/>

            <v-flex xs4 sm3 md2>
              <v-label>User name</v-label>
            </v-flex>
            <v-flex xs5 sm5 md3>
              <v-text-field color="teal" v-model="mailServerUser" autocomplete="offit"></v-text-field>
            </v-flex>
            <v-flex xs3 sm4 md7/>

            <v-flex xs4 sm3 md2>
              <v-label>Password</v-label>
            </v-flex>
            <v-flex xs5 sm5 md3>
              <v-text-field color="teal" type="password" v-model="mailServerPassword" autocomplete="offit"></v-text-field>
            </v-flex>
            <v-flex xs3 sm4 md7/>
          </Panel>
          <Panel title="Sender">
            <v-flex xs4 sm3 md2>
              <v-label>From email</v-label>
            </v-flex>
            <v-flex xs6 sm6 md4>
              <v-text-field color="teal" v-model="mailFromEmail" autocomplete="offit"></v-text-field>
            </v-flex>
            <v-flex xs2 sm3 md6/>

            <v-flex xs4 sm3 md2>
              <v-label>From name</v-label>
            </v-flex>
            <v-flex xs6 sm6 md4>
              <v-text-field color="teal" v-model="mailFromName" autocomplete="offit"></v-text-field>
            </v-flex>
            <v-flex xs2 sm3 md6/>
          </Panel>
        </v-tab-item>

        <v-tab v-on:click="loadTemplate">Templates</v-tab>
        <v-tab-item>
          <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
            <v-layout>
              <v-flex text-xs-right>
                <v-btn flat v-on:click="showSource = !showSource" class="bw-5">Show {{ showSource ? 'formatted' : 'source'}}</v-btn>
                <v-btn flat v-on:click="saveTemplate">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <Panel>
            <v-container fluid pa-1>
              <v-layout wrap>
                <v-flex xs12 md2 py-1>
                  <v-label>Template</v-label>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select :items="templates" v-model="currentTemplateKey" item-text="label" item-value="key" v-on:change="loadTemplate"></v-select>
                </v-flex>
                <v-flex md6></v-flex>
                <v-flex xs12 md2 py-1 v-if="currentTemplate">
                  <v-label>Subject</v-label>
                </v-flex>
                <v-flex xs12 md10 v-if="currentTemplate">
                  <v-text-field color="teal" v-model="currentTemplate.values.subject" autocomplete="offit"></v-text-field>
                </v-flex>
                <v-flex xs12 py-1 v-if="currentTemplate">
                  <v-label>Message</v-label>
                </v-flex>
                <v-flex xs12 py-2 v-if="currentTemplate">
                  <wysiwyg v-model="currentTemplate.values.body" v-if="!showSource" class="configuration-template"></wysiwyg>
                  <v-textarea solo v-model="currentTemplate.values.body" rows="10" class="configuration-template-plain" v-if="showSource"></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </Panel>
        </v-tab-item>

        <v-tab v-on:click="loadEconomic">e-conomic</v-tab>
        <v-tab-item>
          <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
            <v-layout>
              <v-flex text-xs-right>
                <v-btn flat v-on:click="saveEconomic" class="bw-3">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <Panel title="Integration">
            <v-flex xs4 sm3 md2>
              <v-label>Application token</v-label>
            </v-flex>
            <v-flex xs6 sm6 md4>
              <v-text-field color="teal" v-model="eConomicApplicationToken" autocomplete="offit" @change="dirty = true" @keyup="dirty = true"></v-text-field>
            </v-flex>
            <v-flex xs2 sm3 md6/>

            <v-flex xs4 sm3 md2>
              <v-label>Agreement grant token</v-label>
            </v-flex>
            <v-flex xs6 sm6 md4>
              <v-text-field color="teal" v-model="eConomicAgreementGrantToken" autocomplete="offit" @change="dirty = true" @keyup="dirty = true"></v-text-field>
            </v-flex>
            <v-flex xs2 sm3 md6/>
            <v-flex xs4 sm3 md2>
              <v-label>Default product number</v-label>
            </v-flex>
            <v-flex xs6 sm6 md4>
              <v-text-field color="teal" v-model="economicDefaultProductNumber" autocomplete="offit" @change="dirty = true" @keyup="dirty = true" style="width: 150px;"></v-text-field>
            </v-flex>
            <v-flex xs2 sm3 md6/>

            <v-flex xs12>
              <v-btn flat @click="testEconomic" :disabled="!canTestEconomic" class="bw-6">Test connection</v-btn>
            </v-flex>
          </Panel>
        </v-tab-item>

        <v-tab v-on:click="loadProduction">Season</v-tab>
        <v-tab-item>
          <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
            <v-layout>
              <v-flex text-xs-right>
                <v-btn flat v-on:click="confirmStartProduction" class="bw-6">Start new season</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <Panel>
            <v-container fluid pa-1>
              <v-layout wrap>
                <v-flex xs12 sm4 md2 py-1>
                  <v-label>Current season</v-label>
                </v-flex>
                <v-flex xs12 sm8 md10 py-1 style="line-height: 26px;">
                  {{ currentProduction ? currentProduction.name : 'None'}}
                </v-flex>

                <v-flex xs12 sm4 md2 py-1 v-if="hasProduction">
                  <v-label>Started</v-label>
                </v-flex>
                <v-flex xs12 sm8 md10 py-1 style="line-height: 26px;" v-if="hasProduction">
                  {{ currentProduction.from}}
                </v-flex>

                <v-flex xs12 sm4 md2 py-1 v-if="hasArchivedProductions">
                  <v-label>Archived season</v-label>
                </v-flex>
                <v-flex xs12 sm8 md6 py-1 style="line-height: 26px;" v-if="hasArchivedProductions">
                  <v-select v-model="archivedProduction" :items="archivedProductions" item-text="name" return-object style="max-width: 300px; display: inline-block; margin-right: 6px;"/>
                  <v-btn flat @click="selectArchivedProduction" v-if="archivedProduction" class="bw-3">Select</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </Panel>
        </v-tab-item>

      </v-tabs>
    </v-content>
    <Footer/>

    <v-dialog v-model="confirmDeletePickupAddressDialog" persistent width="400">
      <v-card pa-5>
        <v-card-title class="headline">Delete loading address</v-card-title>
        <v-card-text>Are you sure you want to delete this loading address?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.deletePickupAddress">Yes</v-btn>
          <v-btn flat @click="confirmDeletePickupAddressDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDeleteCategoryColorDialog" persistent width="400">
      <v-card pa-5>
        <v-card-title class="headline">Delete category color</v-card-title>
        <v-card-text>Are you sure you want to delete this category color?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.deleteCategoryColor">Yes</v-btn>
          <v-btn flat @click="confirmDeleteCategoryColorDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDeleteFamilyDialog" persistent width="400">
      <v-card pa-5>
        <v-card-title class="headline">Delete category family</v-card-title>
        <v-card-text>Are you sure you want to delete this category family?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.deleteFamily">Yes</v-btn>
          <v-btn flat @click="confirmDeleteFamilyDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDeleteOptionDialog" persistent width="400">
      <v-card pa-5>
        <v-card-title class="headline">Delete option</v-card-title>
        <v-card-text>Are you sure you want to delete this option?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.deleteOption">Yes</v-btn>
          <v-btn flat @click="confirmDeleteOptionDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="startProductionDialog" persistent width="400">
      <v-card pa-5>
        <v-card-title class="headline">Start new season</v-card-title>
        <v-card-text style="padding: 20px;">
          <table>
            <tr>
              <td colspan="2" style="padding-bottom: 15px;">Archive the season and start a new one.</td>
            </tr>
            <tr>
              <td style="width: 200px;"><v-label>Name of new season</v-label></td>
              <td style="padding-right: 30px;"><v-text-field color="teal" v-model="productionName" autocomplete="offit"/></td>
            </tr>
            <tr v-if="startProductionError !== ''">
              <td colspan="2" style="color: red; font-weight: bold; padding: 5px 5px 0 5px; text-align: center;">{{ startProductionError }}</td>
            </tr>
          </table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="confirmNewProduction" :disabled="startProductionButtonDisabled">Continue</v-btn>
          <v-btn flat @click="cancelNewProduction">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="startProductionConfirmDialog" persistent width="450">
      <v-card pa-5>
        <v-card-title class="headline">Start new season</v-card-title>
        <v-card-text style="padding: 20px;">
          <table>
            <tr>
              <td style="padding-bottom: 15px;">You are about to archive the current season and start a new one with name '{{ productionName }}'.</td>
            </tr>
            <tr>
              <td style="padding-bottom: 15px;">Are you sure you want to continue?</td>
            </tr>
          </table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="startNewProduction">Yes</v-btn>
          <v-btn flat @click="cancelNewProduction">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorDialog" persistent width="400">
      <v-card pa-5>
        <v-card-title class="headline">{{errorTitle && errorTitle !== '' ? errorTitle : 'Error'}}</v-card-title>
        <v-card-text>{{errorMessage}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="errorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Panel from '../components/Panel'
import Maps from '../components/Maps'
import PanelColumn from '../components/PanelColumn'
import PanelColumn2 from '../components/PanelColumn2'
import axios from 'axios'
import querystring from 'querystring'
import NumberUtil from '@/assets/javascript/numberutil'

export default {
  name: 'Configuration',
  components: {Header, Sidebar, Footer, Panel, PanelColumn, PanelColumn2, Maps},
  methods: {
    loadMailServer () {
      // console.log('Load mail server configuration')
      this.$store.dispatch('configuration/loadMailServerConfiguration')
        .then((response) => {
          // console.log('Mail server configuration loaded')
          // console.log('Mail server configuration loaded: ' + response)
          this.mailServerHost = this.$store.state.configuration.mailServerHost
          this.mailServerPort = this.$store.state.configuration.mailServerPort
          this.mailServerUser = this.$store.state.configuration.mailServerUser
          this.mailServerPassword = this.$store.state.configuration.mailServerPassword
          this.mailFromEmail = this.$store.state.configuration.mailFromEmail
          this.mailFromName = this.$store.state.configuration.mailFromName
        })
        .catch((error) => {
          console.log('Error: \'' + error.message + '\'')
        })
    },
    saveMailServer () {
      // console.log('Save mail server configuration')
      let mailServer = {
        host: this.mailServerHost,
        port: this.mailServerPort,
        user: this.mailServerUser,
        password: this.mailServerPassword,
        fromEmail: this.mailFromEmail,
        fromName: this.mailFromName
      }
      this.$store.dispatch('configuration/saveMailServer', mailServer)
        .then((response) => {
          // console.log('Mail server configuration saved: ' + response)
        })
        .catch((error) => {
          console.log('Error: \'' + error.message + '\'')
        })
    },
    loadTemplate () {
      this.currentTemplate = null
      for (let t of this.templates) {
        if (t.key === this.currentTemplateKey) {
          this.currentTemplate = t
          break
        }
      }
      // console.log('Load template for ' + this.currentTemplate.key)
      if (this.currentTemplate.key === 'MAIL_WELCOME') {
        // Load welcome email configuration
        axios.get('/backend/rest/configuration/TemplateMailWelcomeSubject')
          .then(response => {
            this.currentTemplate.values.subject = response.data.value
          })
        axios.get('/backend/rest/configuration/TemplateMailWelcomeBody')
          .then(response => {
            this.currentTemplate.values.body = response.data.value
          })
      } else if (this.currentTemplate.key === 'MAIL_RESET_PASSWORD') {
        // Load welcome email configuration
        axios.get('/backend/rest/configuration/TemplateMailResetPasswordSubject')
          .then(response => {
            this.currentTemplate.values.subject = response.data.value
          })
        axios.get('/backend/rest/configuration/TemplateMailResetPasswordBody')
          .then(response => {
            this.currentTemplate.values.body = response.data.value
          })
      } else if (this.currentTemplate.key === 'MAIL_FORGOT_PASSWORD') {
        // Load welcome email configuration
        axios.get('/backend/rest/configuration/TemplateMailForgotPasswordSubject')
          .then(response => {
            this.currentTemplate.values.subject = response.data.value
          })
        axios.get('/backend/rest/configuration/TemplateMailForgotPasswordBody')
          .then(response => {
            this.currentTemplate.values.body = response.data.value
          })
      } else if (this.currentTemplate.key === 'MAIL_DELIVERY_NOTE_DANISH') {
        axios.get('/backend/rest/configuration/TemplateMailDeliveryNoteSubject_da')
          .then(response => {
            this.currentTemplate.values.subject = response.data.value
          })
        axios.get('/backend/rest/configuration/TemplateMailDeliveryNoteBody_da')
          .then(response => {
            this.currentTemplate.values.body = response.data.value
          })
      } else if (this.currentTemplate.key === 'MAIL_DELIVERY_NOTE_ENGLISH') {
        axios.get('/backend/rest/configuration/TemplateMailDeliveryNoteSubject_en')
          .then(response => {
            this.currentTemplate.values.subject = response.data.value
          })
        axios.get('/backend/rest/configuration/TemplateMailDeliveryNoteBody_en')
          .then(response => {
            this.currentTemplate.values.body = response.data.value
          })
      } else if (this.currentTemplate.key === 'MAIL_DELIVERY_NOTE_GERMAN') {
        axios.get('/backend/rest/configuration/TemplateMailDeliveryNoteSubject_de')
          .then(response => {
            this.currentTemplate.values.subject = response.data.value
          })
        axios.get('/backend/rest/configuration/TemplateMailDeliveryNoteBody_de')
          .then(response => {
            this.currentTemplate.values.body = response.data.value
          })
      }
    },
    saveTemplate () {
      // console.log('Save template for ' + this.currentTemplate.key)
      if (this.currentTemplate.key === 'MAIL_WELCOME') {
        // Save welcome email configuration
        axios.post('/backend/rest/configuration', querystring.stringify({ key: 'TemplateMailWelcomeSubject', value: this.currentTemplate.values.subject }))
        axios.post('/backend/rest/configuration', querystring.stringify({ key: 'TemplateMailWelcomeBody', value: this.currentTemplate.values.body }))
      } else if (this.currentTemplate.key === 'MAIL_RESET_PASSWORD') {
        // Save welcome email configuration
        axios.post('/backend/rest/configuration', querystring.stringify({ key: 'TemplateMailResetPasswordSubject', value: this.currentTemplate.values.subject }))
        axios.post('/backend/rest/configuration', querystring.stringify({ key: 'TemplateMailResetPasswordBody', value: this.currentTemplate.values.body }))
      } else if (this.currentTemplate.key === 'MAIL_FORGOT_PASSWORD') {
        // Save welcome email configuration
        axios.post('/backend/rest/configuration', querystring.stringify({ key: 'TemplateMailForgotPasswordSubject', value: this.currentTemplate.values.subject }))
        axios.post('/backend/rest/configuration', querystring.stringify({ key: 'TemplateMailForgotPasswordBody', value: this.currentTemplate.values.body }))
      } else if (this.currentTemplate.key === 'MAIL_DELIVERY_NOTE_DANISH') {
        axios.post('/backend/rest/configuration', querystring.stringify({ key: 'TemplateMailDeliveryNoteSubject_da', value: this.currentTemplate.values.subject }))
        axios.post('/backend/rest/configuration', querystring.stringify({ key: 'TemplateMailDeliveryNoteBody_da', value: this.currentTemplate.values.body }))
      } else if (this.currentTemplate.key === 'MAIL_DELIVERY_NOTE_ENGLISH') {
        axios.post('/backend/rest/configuration', querystring.stringify({ key: 'TemplateMailDeliveryNoteSubject_en', value: this.currentTemplate.values.subject }))
        axios.post('/backend/rest/configuration', querystring.stringify({ key: 'TemplateMailDeliveryNoteBody_en', value: this.currentTemplate.values.body }))
      } else if (this.currentTemplate.key === 'MAIL_DELIVERY_NOTE_GERMAN') {
        axios.post('/backend/rest/configuration', querystring.stringify({ key: 'TemplateMailDeliveryNoteSubject_de', value: this.currentTemplate.values.subject }))
        axios.post('/backend/rest/configuration', querystring.stringify({ key: 'TemplateMailDeliveryNoteBody_de', value: this.currentTemplate.values.body }))
      }
    },
    loadPickupAddresses () {
      this.pickupAddresses = []
      // console.log('Loading pickup addresses')
      axios.get('/backend/rest/pickup_address')
        .then(response => {
          // console.log('Response data: ' + Object.keys(response))
          this.pickupAddresses = response.data
          // console.log('Pickup addresses: ' + this.pickupAddresses)
        })
    },
    selectPickupAddress (item) {
      for (let c of this.pickupAddresses) {
        if (c.id === item.id) {
          this.currentPickupAddress = c
          if (this.currentPickupAddress.latitude === 0) {
            this.currentPickupAddress.latitude = ''
          }
          if (this.currentPickupAddress.longitude === 0) {
            this.currentPickupAddress.longitude = ''
          }
          break
        }
      }
    },
    addPickupAddress () {
      this.currentPickupAddress = {
        id: 0,
        street: '',
        houseNo: '',
        location: '',
        zipCode: '',
        city: '',
        country: '',
        latitude: '',
        longitude: ''
      }
      this.$nextTick(() => this.$refs.deliveryAddressStreet.focus())
    },
    savePickupAddress () {
      // console.log('Save the pickup address')
      axios.post('/backend/rest/pickup_address', this.currentPickupAddress)
        .then(response => {
          // console.log('Got response: ' + response)
          this.loadPickupAddresses()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentPickupAddress = null
    },
    deletePickupAddress () {
      axios.delete('/backend/rest/pickup_address/' + this.currentPickupAddress.id)
        .then(response => {
          // console.log('Got response: ' + response)

          this.loadPickupAddresses()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.confirmDeletePickupAddressDialog = false
      this.currentPickupAddress = null
    },
    cancelPickupAddress () {
      this.currentPickupAddress = null
    },
    loadEmployeeTasks () {
      this.employeeTasks = []
      axios.get('/backend/rest/employee/task')
        .then(response => {
          this.employeeTasks = response.data
        })
    },
    selectEmployeeTask (item) {
      for (let et of this.employeeTasks) {
        if (et.id === item.id) {
          this.currentEmployeeTask = et
          break
        }
      }
    },
    addEmployeeTask () {
      this.currentEmployeeTask = {
        id: 0,
        title: '',
        description: ''
      }
      this.$nextTick(() => this.$refs.employeeTaskTitle.focus())
    },
    saveEmployeeTask () {
      axios.post('/backend/rest/employee/task', this.currentEmployeeTask)
        .then(response => {
          this.loadEmployeeTasks()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentEmployeeTask = null
    },
    deleteEmployeeTask () {
      axios.delete('/backend/rest/employee/task/' + this.currentEmployeeTask.id)
        .then(response => {
          this.loadEmployeeTasks()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.confirmDeleteEmployeeTaskDialog = false
      this.currentEmployeeTask = null
    },
    cancelEmployeeTask () {
      this.currentEmployeeTask = null
    },
    loadTimeRegistration () {
      this.currentTimeRegistration = null
      this.currentTimeRegistration = {
        startDay: 1
      }
      axios.get('/backend/rest/configuration/TimeRegistrationStartDay')
        .then(response => {
          this.currentTimeRegistration.startDay = Number(response.data.value)
        })
    },
    saveTimeRegistration () {
      axios.post('/backend/rest/configuration', querystring.stringify({ key: 'TimeRegistrationStartDay', value: this.currentTimeRegistration.startDay.toFixed(0) }))
    },
    loadForecast () {
      this.forecastFoundationSeasonCount = ''
      this.forecastYears = ''
      axios.get('/backend/rest/configuration/ForecastFoundationSeasonCount')
        .then(response => {
          this.forecastFoundationSeasonCount = response.data.value
        })
      axios.get('/backend/rest/configuration/ForecastYears')
        .then(response => {
          this.forecastYears = response.data.value
        })
    },
    saveForecast () {
      axios.post('/backend/rest/configuration', querystring.stringify({ key: 'ForecastFoundationSeasonCount', value: this.forecastFoundationSeasonCount }))
      axios.post('/backend/rest/configuration', querystring.stringify({ key: 'ForecastYears', value: this.forecastYears }))
      axios.post('/backend/rest/forecast/cache/clear')
      this.dirty = false
    },
    createTestPallets () {
      // console.log('Create test pallets')
      axios.post('/backend/rest/pickup_address/' + this.currentPickupAddress.id + '/create_test_pallets')
        .then(response => {
          // console.log('Got response: ' + response)
          // alert('Test pallets created successfully')
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
    },
    loadCategoryColors () {
      this.categoryColors = []
      axios.get('/backend/rest/color')
        .then(response => {
          this.categoryColors = response.data
        })
    },
    selectCategoryColor (item) {
      for (let c of this.categoryColors) {
        if (c.id === item.id) {
          this.currentCategoryColor = c
          let colors = this.colorsFromString(this.currentCategoryColor.color)
          this.colorRed = colors[0]
          this.colorGreen = colors[1]
          this.colorBlue = colors[2]
          this.hasSecondColor = this.currentCategoryColor.secondColor && this.currentCategoryColor.secondColor !== ''
          if (this.hasSecondColor) {
            let secondColors = this.colorsFromString(this.currentCategoryColor.secondColor)
            this.secondColorRed = secondColors[0]
            this.secondColorGreen = secondColors[1]
            this.secondColorBlue = secondColors[2]
          }
          break
        }
      }
    },
    addCategoryColor () {
      this.currentCategoryColor = {
        id: 0,
        name: '',
        color: '',
        secondColor: ''
      }
      this.colorRed = 255
      this.colorGreen = 255
      this.colorBlue = 255
      this.hasSecondColor = false
      this.secondColorRed = 255
      this.secondColorGreen = 255
      this.secondColorBlue = 255
      this.$nextTick(() => this.$refs.categoryColorName.focus())
    },
    saveCategoryColor () {
      // console.log('Save the category color')
      this.currentCategoryColor.color = this.color
      this.currentCategoryColor.secondColor = this.hasSecondColor ? this.secondColor : ''
      axios.post('/backend/rest/color', this.currentCategoryColor)
        .then(response => {
          // console.log('Got response: ' + response)
          this.loadCategoryColors()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentCategoryColor = null
    },
    deleteCategoryColor () {
      axios.delete('/backend/rest/color/' + this.currentCategoryColor.id)
        .then(response => {
          // console.log('Got response: ' + response)

          this.currentCategoryColor = null
          this.loadCategoryColors()
        })
        .catch(error => {
          this.confirmDeleteCategoryColorDialog = false
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })
      this.confirmDeleteCategoryColorDialog = false
    },
    cancelCategoryColor () {
      this.currentCategoryColor = null
    },
    loadFamilies () {
      this.families = []
      axios.get('/backend/rest/family')
        .then(response => {
          this.families = response.data
        })
    },
    selectFamily (item) {
      for (let f of this.families) {
        if (f.id === item.id) {
          this.currentFamily = f
          break
        }
      }
    },
    addFamily () {
      this.currentFamily = {
        id: 0,
        quality: '',
        label: ''
      }
      this.$nextTick(() => this.$refs.familyQuality.focus())
    },
    saveFamily () {
      axios.post('/backend/rest/family', this.currentFamily)
        .then(response => {
          this.loadFamilies()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentFamily = null
    },
    deleteFamily () {
      axios.delete('/backend/rest/family/' + this.currentFamily.id)
        .then(response => {
          // console.log('Got response: ' + response)

          this.currentFamily = null
          this.loadFamilies()
        })
        .catch(error => {
          this.confirmDeleteFamilyDialog = false
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })
      this.confirmDeleteFamilyDialog = false
    },
    cancelFamily () {
      this.currentFamily = null
    },
    loadOptions () {
      this.options = []
      axios.get('/backend/rest/option/all')
        .then(response => {
          this.options = response.data
        })
    },
    selectOption (item) {
      for (let o of this.options) {
        if (o.id === item.id) {
          this.currentOption = o
          break
        }
      }
    },
    addOption () {
      this.currentOption = {
        id: 0,
        name: '',
        inactive: false
      }
      this.$nextTick(() => this.$refs.optionName.focus())
    },
    saveOption () {
      axios.post('/backend/rest/option', this.currentOption)
        .then(response => {
          this.loadOptions()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
      this.currentOption = null
    },
    deleteOption () {
      axios.delete('/backend/rest/option/' + this.currentOption.id)
        .then(response => {
          // console.log('Got response: ' + response)

          this.currentOption = null
          this.loadOptions()
        })
        .catch(error => {
          this.confirmDeleteOptionDialog = false
          console.log(error.response.data)
          this.errorTitle = error.response.data.title
          this.errorMessage = error.response.data.message
          this.errorDialog = true
        })
      this.confirmDeleteOptionDialog = false
    },
    cancelOption () {
      this.currentOption = null
    },
    loadEconomic () {
      axios.get('/backend/rest/configuration/EconomicApplicationToken')
        .then(response => {
          this.eConomicApplicationToken = response.data.value
        })
      axios.get('/backend/rest/configuration/EconomicAgreementGrantToken')
        .then(response => {
          this.eConomicAgreementGrantToken = response.data.value
        })
      axios.get('/backend/rest/configuration/EconomicDefaultProductNumber')
        .then(response => {
          this.economicDefaultProductNumber = response.data.value
        })
      this.dirty = false
    },
    saveEconomic () {
      axios.post('/backend/rest/configuration', querystring.stringify({ key: 'EconomicApplicationToken', value: this.eConomicApplicationToken }))
      axios.post('/backend/rest/configuration', querystring.stringify({ key: 'EconomicAgreementGrantToken', value: this.eConomicAgreementGrantToken }))
      axios.post('/backend/rest/configuration', querystring.stringify({ key: 'EconomicDefaultProductNumber', value: this.economicDefaultProductNumber }))
      this.dirty = false
    },
    testEconomic () {
      if (this.economicDefaultProductNumber !== '') {
        axios.get('/backend/rest/configuration/economic/product/' + this.economicDefaultProductNumber)
          .then(response => {
            this.$refs.header.showSnackbar('Default product number was found in e-conomic')
          })
          .catch(() => {
            this.$refs.header.showSnackbar('Default product number was not found in e-conomic')
          })
      } else {
        axios.get('/backend/rest/configuration/economic/test')
          .then(response => {
            this.$refs.header.showSnackbar('Connection test was successful')
          })
          .catch(() => {
            this.$refs.header.showSnackbar('Failed to connect to e-conomic')
          })
      }
    },
    loadProduction () {
      this.currentProduction = null
      // console.log('Loading current production')
      axios.get('/backend/rest/production')
        .then(response => {
          this.currentProduction = response.data
          this.loadArchivedProductions()
        })
    },
    confirmStartProduction () {
      this.productionName = '' + new Date().getFullYear()
      this.startProductionError = ''
      this.openStartProductionDialog()
    },
    openStartProductionDialog () {
      this.startProductionDialog = true
    },
    confirmNewProduction () {
      this.startProductionDialog = false
      this.startProductionConfirmDialog = true
    },
    startNewProduction () {
      axios.post('/backend/rest/production/start', { name: this.productionName })
        .then(response => {
          this.loadProduction()
          this.startProductionDialog = false
          this.startProductionConfirmDialog = false
        })
        .catch(error => {
          let errorMessage = 'Failed to start new production'
          if (error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message
          }
          console.log(errorMessage)
          this.startProductionError = errorMessage
          this.startProductionConfirmDialog = false
          this.$nextTick(() => this.openStartProductionDialog())
        })
    },
    cancelNewProduction () {
      this.startProductionDialog = false
      this.startProductionConfirmDialog = false
    },
    loadArchivedProductions () {
      axios.get('/backend/rest/production/all')
        .then(response => {
          let productions = response.data
          if (productions && productions.length > 0 && this.currentProduction) {
            productions = productions.filter(p => p.name !== this.currentProduction.name)
          }
          this.archivedProductions = productions
        })
    },
    selectArchivedProduction () {
      if (this.archivedProduction) {
        axios.post('/backend/rest/production/select/' + this.archivedProduction.id)
          .then(response => {
            let production = response.data
            this.$store.dispatch('session/startArchivedProduction', production)
          })
      }
    },
    asHex (number) {
      let hex = Math.round(number).toString(16)
      if (hex.length < 2) {
        hex = '0' + hex
      }
      return hex.toUpperCase()
    },
    asString (hex) {
      return parseInt(hex, 16)
    },
    colorsFromString (colorString) {
      if (colorString && colorString.length === 6) {
        let red = colorString.substr(0, 2)
        let green = colorString.substr(2, 2)
        let blue = colorString.substr(4, 2)
        return [this.asString(red), this.asString(green), this.asString(blue)]
      }
      return [255, 255, 255]
    }
  },
  computed: {
    color: function () {
      return this.asHex(this.colorRed) + this.asHex(this.colorGreen) + this.asHex(this.colorBlue)
    },
    secondColor: function () {
      return this.hasSecondColor ? this.asHex(this.secondColorRed) + this.asHex(this.secondColorGreen) + this.asHex(this.secondColorBlue) : ''
    },
    colorCss: function () {
      if (this.hasSecondColor) {
        return 'background: repeating-linear-gradient(-45deg, #' + this.color + ', #' + this.color + ' 3px, #' + this.secondColor + ' 3px, #' + this.secondColor + ' 6px);'
      }
      return 'background-color: #' + this.color + ';'
    },
    colorText: function () {
      let colorAverage = (this.colorRed + this.colorGreen + this.colorBlue) / 3
      let colorMax = Math.max(this.colorRed, Math.max(this.colorGreen, this.colorBlue))
      return colorAverage > 120 || colorMax > 230 ? 'black' : 'white'
    },
    hasProduction: function () {
      return this.currentProduction && this.currentProduction.id
    },
    hasArchivedProductions: function () {
      return this.archivedProductions.length > 0
    },
    startProductionButtonDisabled: function () {
      return this.productionName.trim() === ''
    },
    canTestEconomic: function () {
      return !this.dirty && this.eConomicApplicationToken && this.eConomicApplicationToken.trim() !== '' && this.eConomicAgreementGrantToken && this.eConomicAgreementGrantToken.trim() !== ''
    },
    saveForecastDisabled: function () {
      if (this.dirty) {
        if (!(!this.forecastFoundationSeasonCount || this.forecastFoundationSeasonCount === '' || NumberUtil.isPositiveInteger(this.forecastFoundationSeasonCount))) {
          return true
        }
        if (!(!this.forecastYears || this.forecastYears === '' || NumberUtil.isPositiveInteger(this.forecastYears))) {
          return true
        }
        return false
      }
      return true
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'configuration' })
    this.loadCategoryColors()
  },
  data () {
    return {
      active: null,
      mailServerHost: '',
      mailServerPort: '',
      mailServerUser: '',
      mailServerPassword: '',
      mailFromEmail: '',
      mailFromName: '',
      templates: [
        {
          key: 'MAIL_WELCOME',
          label: 'Welcome email',
          values: {
            subject: '',
            body: ''
          }
        },
        {
          key: 'MAIL_RESET_PASSWORD',
          label: 'Reset password email',
          values: {
            subject: '',
            body: ''
          }
        },
        {
          key: 'MAIL_DELIVERY_NOTE_DANISH',
          label: 'Delivery note in Danish',
          values: {
            subject: '',
            body: ''
          }
        },
        {
          key: 'MAIL_DELIVERY_NOTE_ENGLISH',
          label: 'Delivery note in English',
          values: {
            subject: '',
            body: ''
          }
        },
        {
          key: 'MAIL_DELIVERY_NOTE_GERMAN',
          label: 'Delivery note in German',
          values: {
            subject: '',
            body: ''
          }
        }
      ],
      currentTemplateKey: 'MAIL_WELCOME',
      currentTemplate: null,
      showSource: false,
      pickupAddressHeaders: [
        { text: 'Street', value: 'street', sortable: true },
        { text: 'No.', value: 'houseNo', sortable: true },
        { text: 'Location', value: 'location', sortable: true },
        { text: 'Postal code', value: 'zipCode', sortable: true },
        { text: 'City', value: 'city', sortable: true },
        { text: 'Country', value: 'country', sortable: true }
      ],
      pickupAddresses: [],
      currentPickupAddress: null,
      confirmDeletePickupAddressDialog: false,
      employeeTaskHeaders: [
        { text: 'Title', value: 'title', sortable: true },
        { text: 'Description', value: 'description', sortable: false }
      ],
      employeeTasks: [],
      currentEmployeeTask: null,
      confirmDeleteEmployeeTaskDialog: false,
      currentTimeRegistration: null,
      categoryColorHeaders: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Color', value: 'color', sortable: false }
      ],
      familyHeaders: [
        { text: 'Quality', value: 'quality', sortable: false },
        { text: 'Label', value: 'label', sortable: false }
      ],
      optionHeaders: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Inactive', value: 'inactive', sortable: true }
      ],
      categoryColors: [],
      currentCategoryColor: null,
      confirmDeleteCategoryColorDialog: false,
      colorRed: 255,
      colorGreen: 255,
      colorBlue: 255,
      hasSecondColor: false,
      secondColorRed: 255,
      secondColorGreen: 255,
      secondColorBlue: 255,
      families: [],
      currentFamily: null,
      confirmDeleteFamilyDialog: false,
      options: [],
      currentOption: null,
      confirmDeleteOptionDialog: false,
      eConomicApplicationToken: '',
      eConomicAgreementGrantToken: '',
      economicDefaultProductNumber: '',
      forecastFoundationSeasonCount: null,
      forecastYears: null,
      dirty: false,
      currentProduction: null,
      archivedProductions: [],
      archivedProduction: null,
      productionName: '',
      startProductionError: '',
      startProductionDialog: false,
      startProductionConfirmDialog: false,
      errorDialog: false,
      errorTitle: '',
      errorMessage: ''
    }
  }
}
</script>

<style scoped>
  .tabs {
  }
  .tabs .v-tabs__div {
    width: 110px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Configuration.vue